import { Collapsible } from "./base/CollapsibleBase"
import { CollapsibleTrigger } from "./base/CollapsibleBase"
import { CollapsibleContent } from "./base/CollapsibleBase"

export default Object.assign(Collapsible, {
  Trigger: CollapsibleTrigger,
  Content: CollapsibleContent,
})
